import { getEULAData } from '../../selectors';

export const eulaDataSelector = (state) => getEULAData(state).data;
